import { HStack, IconButton, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { FiExternalLink, FiX } from 'react-icons/fi';

export interface MealPlanWizardHeaderProps {
  patientName?: string;
  onOpenInNewTab?: () => void;
  onClose?: () => void;
}

/**
 * Shared wizard header for the meal plan drawer and standalone page.
 * Displays "Meal plan for [Patient Name]" with optional action icons.
 *
 * - Drawer: shows open-in-new-tab + close icons
 * - Standalone: no action icons
 */
export const MealPlanWizardHeader: FC<MealPlanWizardHeaderProps> = ({
  patientName,
  onOpenInNewTab,
  onClose,
}) => {
  const hasActions = !!onOpenInNewTab || !!onClose;

  return (
    <HStack
      w="full"
      justify="center"
      position="relative"
      borderBottomWidth="1px"
      borderColor="border.default"
      px={4}
      py={3}
    >
      <Text fontWeight="semibold" fontSize="sm">
        Meal plan for{' '}
        {patientName ? (
          <Text as="span" fontWeight="bold">
            {patientName}
          </Text>
        ) : (
          'patient'
        )}
      </Text>

      {hasActions && (
        <HStack spacing={1} position="absolute" right={4}>
          {onOpenInNewTab && (
            <IconButton
              aria-label="Open meal plan in new tab"
              icon={<FiExternalLink />}
              variant="ghost"
              size="sm"
              onClick={onOpenInNewTab}
            />
          )}
          {onClose && (
            <IconButton
              aria-label="Close meal plan drawer"
              icon={<FiX />}
              variant="ghost"
              size="sm"
              onClick={onClose}
            />
          )}
        </HStack>
      )}
    </HStack>
  );
};
